"use no memo";

/* eslint-disable complexity */
import { format, parse } from 'date-fns';

import { getDateForApiDateStr } from 'helpers/date';
import { FULFILLMENT_METHODS } from 'helpers/order';

export function formatCuisineString(
  cuisine: string[] | string | undefined
): string {
  return Array.isArray(cuisine) ? cuisine.join(', ') : cuisine || '';
}

export function onlyNums(value?: string): string | null {
  if (value === null || value === undefined) {
    return null;
  }

  return value.replace(/[^\d]/g, '');
}

export function removePhoneCountryCode(value?: string): string {
  if (!value) {
    return '';
  }

  // @ts-expect-error its wrong
  return onlyNums(value).slice(-10);
}

export function formatPhone(value?: string): string {
  return value
    ? `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`
    : '';
}

export function formatSimplePhone(value?: string): string {
  return value
    ? `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6, 10)}`
    : '';
}

export function formatDate(dateTime: string | undefined): string {
  const date = getDateForApiDateStr(dateTime);

  // if `date` is an invalid date, `dateTime` was an invalid input
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return format(date, 'EEEE, MMM d');
}

export function formatExpDate(value: string): {
  exp_month: number;
  exp_year: number;
} {
  return {
    exp_month: parseInt(value.slice(0, -3), 10),
    exp_year: parseInt(`20${value.slice(-2)}`, 10),
  };
}

export function formatFulfillMethod(method: string): string {
  return method === FULFILLMENT_METHODS.dineIn ? 'dine-in' : method;
}

export function reverseFormatExpDate(
  expMonth: number,
  expYear: number
): string {
  // NOTE: javascript Date constructor uses 0 for January
  return format(new Date(expYear, expMonth - 1), 'MM/yy');
}

export function formatTime(time: string): string {
  const timeSplit = time.split(':');
  return format(
    new Date(0, 0, 0, Number(timeSplit[0]), Number(timeSplit[1])),
    'h:mm a'
  );
}

export function formatClosure(closure: string): string {
  const parsedDate = parse(closure, 'yyyy-MM-dd HH:mm:ss', new Date());
  const day = format(parsedDate, 'MMM dd');
  const time = format(parsedDate, 'h:mm a');
  return `${day} at ${time}`;
}

export function formatMoney(input?: number) {
  if (input === null || typeof input !== 'number') return '';
  return `$${input.toFixed(2)}`;
}

export function formatDiscount(price: number): string {
  if (Number.isInteger(price)) {
    return `$${price}`;
  }
  return formatMoney(price);
}

export function toTitleCase(string?: string): string {
  if (!string) return '';

  return string.charAt(0).toUpperCase() + string.substr(1).toLowerCase();
}

export function prettifyPhoneNumber(phoneNumberString = '') {
  const cleaned = `${phoneNumberString.replace(/\D/g, '')}`;
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return null;
}
